<template>
  <v-container>

    <v-card elevation="0" outlined class="mt-5">


      <v-sheet class="pa-4 d-md-flex">

        <v-sheet class="flex-sm-column">
          <p class="text-h4 ma-0">Account General Information</p>

        </v-sheet>

      </v-sheet>
    </v-card>



    <v-card v-if="account" elevation="1" class="pa-6 mt-5">


      <v-card-text>

        <v-row>
          <v-col cols="12" lg="8">
            <v-text-field v-model="account.name" outlined label="Company Full Name" :rules="[rules.required]" />

            <v-autocomplete v-model="account.timezone" outlined label="Default Time Zone" :items="availableTimeZones" />

          </v-col>


          <v-col cols="12" lg="4">
            <v-img width="140" v-if="account.logoUrl" :src="account.logoUrl" class="ma-auto">
              <template slot="placeholder"> Loading Logo </template>
            </v-img>

            <v-file-input :show-size="true" hint="Please limited logo size to be under 1MB in size" v-model="account.logo"
              label="Company Logo" />

              <v-btn class="mx-2 my-2" v-if="account.logo" @click="updateCompanyLogo"> Update Logo </v-btn>
          </v-col>

        </v-row>



        <v-text-field v-model="account.abbr" label="Company Code" v-show="false" />

        <v-select v-model="account.type" label="Account Type" :items="accountTypes" v-show="false" />
        <v-text-field type="number" v-model="account.userLimit" label="User Limit" v-show="false" />
        <v-text-field type="number" v-model="account.studentLimit" label="Student Limit" v-show="false" />

      </v-card-text>
    </v-card>

    <!-- Hide on-board on default for now -->
    <div class="ma-6 text-center">
      <v-btn @click="openOnboarding"> Start On-boarding Process</v-btn>
    </div>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card elevation="0">
        <v-toolbar color="transparent" elevation="0">
          <v-btn icon color="grey" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="text-subtitle-2 grey--text text-uppercase">Setup your account</v-toolbar-title>
        </v-toolbar>

        <onboarding-form :account-id="this.globalCenter.accountId" @closeOnboarding="dialog = false"
          :key="componentKey"></onboarding-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { config } from "@/config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
import { rules } from "@/store/util/rules.js";
const OnboardingForm = () => import("@/components/common/OnboardingForm.vue");

export default {
  data: () => {
    return {
      baseUrl: config.BASE_URL,
      accountTypes: ["Demo", "Trial", "Standard"],
      availableTimeZones: moment.tz.names(),
      account: null,
      rules,
      dialog: false,
      componentKey: 0,

    };
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading", "globalCenter"]),
  },
  mounted() {

    const showOnBoarding = this.$route.query.onboarding;
    if (showOnBoarding == 1) {
      this.openOnboarding();
    }

    this.initAccount().then((account) => {
      this.account = account;
      if (!this.account.timezone) {
        this.account.timezone = "America/New_York"; //Default
      }
    });
  },
  components: {
    OnboardingForm,
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    openOnboarding() {
      this.componentKey += 1;
      this.dialog = true
    },
    async initAccount() {
      return await this.$axios
        .get("/account/get-my-account", {
          params: {
            accountId: this.globalCenter ? this.globalCenter.accountId : null,
          },
        })
        .then((resp) => {
          return resp.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading account from server");
        });
    },
    updateCompanyLogo() {

      let formData = new FormData();
      if(this.account.logo){
        formData.append('logo', this.account.logo)
      }

      const params = {
        accountId: this.account.id
      }
      debugger;
      this.$axios
        .post("/account/update-logo", formData,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          },
          params
        })
        .then((resp) => {
          // console.log("updated account");
          this.addSuccessMessage("Logo updated");
          this.account.logoUrl = resp.data.logoUrl;
          this.account.logo = null;
          this.dialog = false;
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    },
  },
};
</script>
